<template>
  <f7-page name="sucho-v-podzemnych-vodach" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Sucho v podzemných vodách</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <div class="pzv-legenda-wrap">
      <img src="static/shmu/img/pzv_legenda5.png" class="pzv-legenda">
    </div>

    <div class="pzv-dt" v-if="pzvGeoJsonDt">
      {{ pzvGeoJsonDt*1000 | moment('DD.MM.YYYY HH:mm') }}
    </div>


    <l-map :zoom="zoom"
           :center="center"
           :options="mapOptions"
           ref="mapPzv"
           class="pzv-map"
    >
      <l-control-zoom position="bottomright"  ></l-control-zoom>
      <l-tile-layer
          ref="layerBg"
          :url="url"
          :attribution="attribution"
      />
      <l-tile-layer :url="borderUrl" />
      <l-tile-layer :url="riversUrl" :opacity="0.5" />
      <l-geo-json
          :geojson="pzvGeoJsonData"
          :options="pzvGeoJsonOptions"
      />

      <l-control v-if="isGeolocationEnabled" :position="'bottomright'">
        <div class="leaflet-bar">
          <a @click="geoLocateMap" role="button"><i class="icon f7-icons" style="font-size: 22px;">placemark_fill</i></a>
        </div>
      </l-control>

      <l-control v-if="isGeolocationEnabled && extraParams.clearBtnVar" :position="'bottomright'">
        <div class="leaflet-bar">
          <a @click="clearMarker" role="button"><i class="icon f7-icons" style="font-size: 22px;">xmark</i></a>
        </div>
      </l-control>


    </l-map>


  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import { latLng } from "leaflet";
import { LSvgShapeMarker} from "leaflet-svg-shape-markers";
import { LTriangleMarker} from "leaflet-triangle-marker";


import { LMap, LTileLayer, LImageOverlay, LMarker, LGeoJson, LControlZoom, LControl } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import shmuMixin from "../js/mixin";
import geoLocationMixin from "../js/geoLocationMixin";

var pzv_icn_markers = [];
var pzv_icn_markers2 = [];






var colors_def = {
  'default':          'rgba(186,186,186,1)',
  'f10':           'rgba(255,80,80,1)',
  'f40':           'rgba(255,204,153,1)',
  'f60':           'rgba(255,255,255,1)',
  'f90':           'rgba(175,194,247,1)',
  'f90p':          'rgba(102,153,255,1)'
};



export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LImageOverlay,
    LGeoJson,
    LControlZoom,
    LControl
  },
  mixins: [
    shmuMixin,
    geoLocationMixin
  ],
  data: function () {
    return {
      lastUpdated: 0,
      tCheckInterval: null,
      isGeoJsonLoaded: false,
      pzvGeoJsonDt: null,
      pzvGeoJsonData: {
        "type": "FeatureCollection",
        "crs": {
          "type": "name",
          "properties": {
            "name": "EPSG:4326"
          }
        },
        "features": []
      },
      pzvGeoJsonOptions: {
        onEachFeature:this.openPzvDetailFromFeature,
        pointToLayer: this.makePzvPoint,
      },
      mapOptions: {
        zoomControl: false,
        zoomSnap: 0.5,
        maxBounds: [[51.7, 25.79], [45.05, 10.6]],
        minZoom: 6,
        maxZoom: 12
      },
      zoom: 6.5,
      center: latLng(48.688714, 19.696843),
      url: SHMUconf.MAP_TILE_URL + 'data/datatiles/osm/v1/{z}/{x}/{y}.png',
      borderUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/hranice_sk/v1/{z}/{x}/{y}.png',
      riversUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/rieky/v2/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright" class="external">OpenStreetMap</a> contributors',


      // geolocation
      extraParams: {
        circleMarkerObject: null,
        pointMarkerObject: null,
        clearBtnVar: false
      },

    };
  },

  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-vodne-zdroje');
    this.$f7.accordion.open('.shmu-i-vodne-zdroje');
    this.$nextTick(() => {
      this.initMap();
    });


  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) {
        this.loadPzvGeoJsonData();
      }

    },
    loadPzvGeoJsonData: function() {
      const self = this;

      let cached_geojson = self.$ls.get('pzv_geojson');
      if (cached_geojson !== null) {
        self.pzvGeoJsonData = cached_geojson;
        self.isGeoJsonLoaded = true;
      } else {

        self.$f7.dialog.preloader('Načítavam...');
        Axios.get(SHMUconf.API_BASE_URL + 'pzv/getgeojson', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.pzvGeoJsonData = response.data;
                self.isGeoJsonLoaded = true;
                self.lastUpdated = self.$moment().unix();
                self.$ls.set('pzv_geojson', self.pzvGeoJsonData, 30 * 60 * 1000); //  10 minut
                // clearInterval(this.tCheckInterval);
                // this.tCheckInterval = setInterval(this.checkLastUpdated, 30 * 60 * 1000); // overujem kazdych 5 min

              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať údaje o podzemných vodách', 'Nastala chyba');
              }
              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }
    },
    initMap() {
      const self = this;
      //this.$refs.mapZrazky.mapObject.ANY_LEAFLET_MAP_METHOD();
      // console.log('leafLet ZRAZKY init done...')

      this.$$('.leaflet-control-attribution a').each((i,item) => {
        self.$$(item).addClass('external')
      });

      this.$refs.mapPzv.mapObject.on('zoomend', function (e) {
        if (this.getZoom() > 9) {
          self.$$('.i-label').css('visibility', 'visible');
        } else {
          self.$$('.i-label').css('visibility', 'hidden');
        }
      });


      // geolocation
      this.locationMapInitEvents(this, this.$refs.mapPzv.mapObject);




    },
    makePzvPoint(feature, latlng) {

      let props = feature.properties;
      let width = 1;
      let radius = 6;

      let prop_state = props.prop_state;
      let prop_type = props.prop_typ;

      var color = colors_def[prop_state];
      if (color == null) color = 'rgba(0,0,0,1)';

      let map = this.$refs.mapPzv.mapObject;

      this.pzvGeoJsonDt = props.prop_dt;

      var  point;

      if (prop_type === 'sonda') {
        point = L.circleMarker(latlng, {
          radius: radius,
          fillColor: color,
          color: "#000",
          weight: width,
          opacity: 1,
          fillOpacity: 0.9
        });
      } else {
        point = L.shapeMarker(latlng, {
          shape: "square",
          radius: radius,
          fillColor: color,
          color: "#000",
          weight: width,
          opacity: 1,
          fillOpacity: 0.9
        });
      }


      let myIcon = L.divIcon({className: 'i-label', html:props.prop_name, iconAnchor:[100,30]});
      pzv_icn_markers[feature.id] = L.marker(latlng, {icon: myIcon}).addTo(map);
      pzv_icn_markers[feature.id]._icon.id = feature.id;
      pzv_icn_markers[feature.id].on({
        click: function (e) {
          self.$f7router.navigate('/podzemne-vody/' + e.target._icon.id);
        }
      });



      return point;



    },
    openPzvDetailFromFeature(feature, layer) {
      const self = this;
      layer.on({
        click: function (v) {
          self.$f7router.navigate('/podzemne-vody/' + v.target.feature.id);
        }
      });

    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) >= 30*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },
    // geolocation
    geoLocateMap() {
      this.locationLocate(this, this.$refs.mapPzv.mapObject, 10);
    },
    clearMarker() {
      this.locationClearMarker(this, this.$refs.mapPzv.mapObject);
    },
    onLocationFound(e) {
      this.locationFound(this, this.$refs.mapPzv.mapObject, e);
    },
    onLocationError(e) {
      this.locationError(this, e);
    }
  }

};
</script>

<style lang="scss">

.pzv-dt {
  position: absolute;
  bottom: 3px;
  left: 3px;
  background: rgba(255,255,255,0.7);
  color: black;
  padding: 5px 10px;
  border: 1px solid #e2e2e2;
  z-index:1001;
}


/* Landscape phone to landscape tablet */
@media (max-width: 979px) {
  .pzv-legenda-wrap {
    z-index: 1100;
    position: absolute;
    top: calc(var(--f7-page-navbar-offset, 0px) + var(--f7-page-toolbar-top-offset, 0px) + var(--f7-page-subnavbar-offset, 0px) + var(--f7-page-searchbar-offset, 0px) + var(--f7-page-content-extra-padding-top, 0px));;
    /*
   bottom:12px;

     */
    left: 0;
    img {
      width: 100%;
      max-width:400px;
      height:auto;
    }
  }
}

/* Small desktop */
@media (min-width: 980px)  {
  .pzv-legenda-wrap {
    z-index: 1100;
    position: absolute;
    top: calc(var(--f7-page-navbar-offset, 0px) + var(--f7-page-toolbar-top-offset, 0px) + var(--f7-page-subnavbar-offset, 0px) + var(--f7-page-searchbar-offset, 0px) + var(--f7-page-content-extra-padding-top, 0px));;

    /*bottom:0; */
    left: 50%;

    .pzv-legenda {
      position:relative;
      left:-50%;
      max-width: 100%;
      height: auto;
      z-index: 1000;
    }
  }
}

.pzv-map {
  width: 100%;
  height: 100%;
}

.i-label2 {
  font-weight: bold;
  color:white;
}

.pzv-toolbar {
  text-align: center;
  font-size:0.8em;
  width:100%;
  margin:0;
  padding: 0;
}


</style>
